import axiosInstance from "./AxiosInstance";

// export function getRoutes(start_point, end_point) {
//   return axiosInstance.get(`${process.env.REACT_APP_API_URL}/api/get_routes`, {params: {start_point, end_point}});
// }

export function getRestaurants(start_point, end_point) {
  return axiosInstance.get(`/api/route_restaurants`, {params: {start_point, end_point}});
}

export function getCompany(slug) {
  return axiosInstance.get(`/api/companies/${slug}`);
}

export function searchRestaurant(name) {
  return axiosInstance.get(`/api/restaurants/search`, {params: {name: name}});
}

// export function searchCity(name) {
//   //return axiosInstance.get(`${process.env.REACT_APP_API_URL}/api/get_city`, {params: {name: name}});
//   return axiosInstance.get('https://autosuggest.search.hereapi.com/v1/autosuggest',
//     {params: {q: name, apiKey: process.env.REACT_APP_HERE_JS_KEY, in: 'countryCode:UKR', at: '50,25'}});
// }

export function requestWaiter(slug, table_id, checkRequest, type, waiterRequestText) {
  const postData = { table_id: table_id, check_request: checkRequest, check_request_type: type,
    waiter_request_text: waiterRequestText};
  return axiosInstance.post(`/api/restaurants/${slug}/waiter_request`, postData);
}

export function askService(slug, serviceId, tableId, message) {
  const postData = { service_id: serviceId, table_id: tableId, message: message};
  return axiosInstance.post(`/api/restaurants/${slug}/request_service`, postData);
}

export function divideCheck(amount, table_id) {
  return axiosInstance.post(`/api/pay_checks/divide`, { amount, table_id });
}

export function claimPayCheck(table_id, pay_check_id, items) {
  return axiosInstance.post(`/api/pay_checks/claim`, { table_id, pay_check_id, items });
}

export function cancelClaimPayCheck(table_id, pay_check_id, child_pay_check_id) {
  return axiosInstance.post(`/api/pay_checks/cancel_claim`, { table_id, pay_check_id, child_pay_check_id });
}

export function updateBillSelection(table_id, pay_check_id, items) {
  return axiosInstance.post(`/api/pay_checks/update_selection`, { table_id, pay_check_id, items });
}

export function clearBillSelection(table_id, pay_check_id) {
  return axiosInstance.delete(`/api/pay_checks/clear_selection`, { data: { table_id, pay_check_id } });
}

export function getPayCheck(restaurant) {
  const postData = { table_id: restaurant.table.id, restaurant_id: restaurant.id};
  return axiosInstance.get(`${process.env.REACT_APP_API_URL}/api/pay_checks`, {params: postData});
}

export function getRestaurantsInArea(latitude, longitude, radius) {
  const config = { params: {location: latitude ? [latitude, longitude] : ['', ''], radius: radius} };
  return axiosInstance.get(`/api/area_restaurants`, config);
}

export function getRestaurantsInBounds(bounds) {
  const config = { params: {bounds: bounds} };
  return axiosInstance.get(`/api/area_restaurants`, config);
}

export function getRestaurant(restaurant_id, table_id, fromMenu) {
  const params = { table_id: !!table_id ? table_id : '', menu: fromMenu };
  return axiosInstance.get(`/api/restaurants/${restaurant_id}`, {params: params});
}

export function getMenu(restaurant_id) {
  return axiosInstance.get(`/api/dishes`, {params: {restaurant_id}});
}

export function getSortedDishes(restaurant_id, sort) {
  return axiosInstance.get(`/api/restaurants/${restaurant_id}/sorted_dishes`, {params: {sort}});
}

export function getRestaurantReviews(restaurant) {
  return axiosInstance.get(`/api/reviews`, {params: {restaurant_id: restaurant.id}});
}

export function getRestaurantImages(restaurant) {
  return axiosInstance.get(`/api/restaurants/${restaurant.id}/images`);
}

export function getCategoryDishes(restaurant, category, withPhoto) {
  return axiosInstance.get(`/api/dishes/category_dishes`,
    {params: {restaurant_id: restaurant.id, category_id: category.id, with_photo: withPhoto,
        only_checkbox: restaurant.table?.room?.only_checkbox}});
}

export function getCategory(restaurant, category) {
  return axiosInstance.get(`/api/category_dishes/${category.id}`, {params: {restaurant_id: restaurant.id}});
}

export function createReview(order_id, comment, rating) {
  const postData = { order_id, comment, rating };
  return axiosInstance.post(`/api/reviews`, postData);
}

export function saveRateDish(dish, kind) {
  const postData = {dish: {kind: kind}};
  return axiosInstance.post(`/api/dishes/${dish.id}/rate_dish`, postData);
}

export function getRestaurantsCategories(params) {
  return axiosInstance.get(`/api/restaurants/categories`, {params: {restaurants: params}});
}

export function dishSearch(restaurant_id, search) {
  return axiosInstance.get(`/api/dishes/search_dish`, {params: {restaurant_id: restaurant_id, search: search}});
}

export function createRestaurant(parameters) {
  return axiosInstance.post(`/api/restaurants`, parameters);
}

export function getRestaurantTables(restaurant) {
  return axiosInstance.get(`/api/restaurants/${restaurant.id}/tables`);
}

export function autoOpenCheckboxShift(slug) {
  return axiosInstance.post(`/api/kiosk`, { slug: slug });
}

export function autoCloseCheckboxShift(slug) {
  return axiosInstance.delete(`/api/kiosk/${slug}`);
}

export function formatReviews(reviewsData) {
  return reviewsData.reviews;
}
